import React, { useState } from "react";
import { useSelector } from "react-redux";
import Table from "../Table";
import AccessibleTooltip from "../Tooltip/Tooltip.js";
import EditIcon from "../../assets/images/editIcon.svg";
import DeleteIcon from "../../assets/images/DeleteIcon.svg";
import PropTypes from "prop-types";

const DeviceTypeData = (props) => {
  const [hasData, setHasData] = useState(true);  
  const {setOpenDeleteModal, setDeviceIdToDelete, setEditDeviceType, setOpenDeviceTypeModal, setOpenDeviceType} = props
  const { data } = useSelector((state) => state.DeviceTypeReducer);

  const handleEdit = (deviceData) => {
    setEditDeviceType(deviceData);
    setOpenDeviceTypeModal("edit");
    setOpenDeviceType(true);
  };
  
  const columns = [
      {
      field: "deviceImage",
      headerName: "Device Type",
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      hideable: false,
      renderCell: (params) => (
        
        <div>
            <img src={params.row.deviceImage} style={{ maxHeight:'40px', maxWidth:'40px'}} />
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      sortable: true,
      disableColumnMenu: false,
      hideable: false,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      sortable: false,
      disableColumnMenu: false,
      hideable: false,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      align: "right",
      headerAlign: "right",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (row) => (
        <div style={{ display: "flex", gap: "10px" }} role="list">
            <div role="listitem">
              <AccessibleTooltip title="Edit">
                <button
                  // role="listitem"
                  id={`edit-${row.id}`}
                  onClick={() => handleEdit(row)}
                  className="icon-btn edit-icon-btn"
                  aria-label="Edit"
                >
                  <img
                    src={EditIcon}
                    alt=""
                    aria-hidden="true"
                    className="editIcon"
                  />
                </button>
              </AccessibleTooltip>
            </div>
           <div role="listitem">
              <AccessibleTooltip title="Delete">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenDeleteModal(true);
                    setDeviceIdToDelete(row.row.id);
                  }}
                  className="icon-btn delete-icon-btn"
                  aria-label="Delete"
                >
                  <img
                    src={DeleteIcon}
                    aria-hidden="true"
                    alt=""
                    className="deleteIcon"
                  />
                </button>
              </AccessibleTooltip>
            </div>
        </div>
      ),
    },
  ];
  const processedRows = Array.isArray(data)
    ? data.map((row, index) => ({
          id: row.id,
          name: row.name || "N/A",
          deviceImage: row?.icons?.idleIcon || "N/A",
          description: row.description || "N/A",
          idleIcon: row?.icons?.idleIcon || "N/A",
          activeIcon: row?.icons?.activeIcon || "N/A",
          brokenIcon: row?.icons?.brokenIcon || "N/A",
          animationFrames: Array.isArray(row?.icons?.animationFrames)
            ? row.icons.animationFrames
            : [],
        }))
    : [];
  return (
    <Table columns={columns} rows={processedRows} setHasData={setHasData} />
  );
};
DeviceTypeData.propTypes = {
  setOpenDeleteModal: PropTypes.func.isRequired,
  setDeviceIdToDelete: PropTypes.func.isRequired,
  setEditDeviceType: PropTypes.func.isRequired,
  setOpenDeviceTypeModal: PropTypes.func.isRequired,
  setOpenDeviceType: PropTypes.func.isRequired,
};
export default DeviceTypeData;
